import React from "react";
import { Link } from "react-router-dom";
import { Zap, ArrowRight } from "lucide-react";

/**
 * Nudge shown when the user hasn't uploaded a new invoice for >= 7 days.
 * Placed near the top of the dashboard so it's seen first on a return visit.
 * Props: { daysSince, totalInvoices, onDismiss? }
 */
export default function UploadReminderNudge({ daysSince, totalInvoices }) {
  if (typeof daysSince !== "number" || daysSince < 7) return null;

  const copy =
    daysSince >= 30
      ? "It's been over a month. Every invoice you skip is savings uncounted."
      : daysSince >= 14
      ? "Two weeks since your last upload. Your Zomato and Blinkit bills keep growing — let's see them."
      : "Don't miss the saving opportunity! Upload your latest purchase invoice.";

  return (
    <div
      className="cartiq-card relative overflow-hidden"
      style={{ background: "rgba(255,107,0,0.06)" }}
      data-testid="upload-reminder-nudge"
    >
      <div
        className="absolute top-0 left-0 right-0 h-[2px]"
        style={{
          background: "linear-gradient(90deg,#FF6B00 0%,#E24B4A 70%,transparent 100%)",
        }}
      />
      <div className="grid md:grid-cols-[auto_1fr_auto] gap-4 items-center">
        <div className="w-11 h-11 bg-[#FF6B00]/15 border border-[#FF6B00]/40 flex items-center justify-center shrink-0">
          <Zap className="w-5 h-5 text-[#FF6B00]" />
        </div>
        <div>
          <div className="text-[11px] uppercase tracking-[0.22em] text-[#FF6B00] font-bold mb-1">
            — {daysSince} days quiet
          </div>
          <h3 className="font-display uppercase text-xl md:text-2xl leading-tight">
            {copy}
          </h3>
          <p className="text-sm text-[#888] mt-1.5 leading-relaxed">
            You've analysed{" "}
            <span className="text-[#F0EDE8] font-mono-num font-bold">{totalInvoices || 0}</span>{" "}
            invoices so far. Add the latest ones — duplicates are auto-skipped.
          </p>
        </div>
        <Link
          to="/"
          className="btn-saffron flex items-center justify-center gap-2 text-sm whitespace-nowrap"
          data-testid="upload-reminder-cta"
        >
          Upload now <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
}
